/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PermissionsEnums {
    TRUE_ADMIN = 2,
    READ_ONLY = 3,
    UNDERWRITING_VIEW = 4,
    UNDERWRITING_QUOTE = 5,
    UNDERWRITTER = 6,
    PROGRAM_ADMIN = 7,
    BILLING_VIEW = 8,
    BILLING_PAYMENT = 9,
    BILLING_USER = 10,
    BILLING_ADMIN = 11,
    CLAIMS_VIEW = 12,
    CLAIMS_ADJUSTER = 13,
    CLAIMS_MANAGER = 14,
    CLAIMS_ADMIN = 15,
    AGENCY_VIEW = 16,
    AGENCY_ADMIN = 17,
    REINSURANCE_VIEW = 18,
    REINSURANCE_ADMIN = 19,
    PORTAL_GENERAL_USER = 20,
    PORTAL_BILLING = 21,
    PORTAL_CLAIMS = 22,
    AGENCY_GENERAL = 23,
    AGENCY_PORTAL_ADMIN = 24,
    AGENCY_SUBMISSION = 25,
    AGENCY_BIND = 26,
    CUSTOMER_ADMIN = 27,
    AGENCY_CLAIMS = 28,
    PORTAL_POLICY = 29,
    PORTAL_LOSS_CONTROL = 30,
    AUDIT_VIEW = 31,
    AUDITOR = 32,
    PORTAL_INSURED_ADMIN = 33,
    UNBIND_QUOTE = 34,
    UNDERWRITER_ALWAYS_VISIBLE = 36,
    PORTAL_INCIDENT = 37,
    AGENT = 39,
}
